<template>
  <v-card>
    <v-toolbar light>
      <v-toolbar-title>
        Surat {{ idJenisForm == 1 ? 'Masuk' : 'Keluar' }} -
        {{ item.index_surat_tu }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon light @click="closeView">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text class="mt-2 mb-2">
      <v-container grid-list-xl class="pt-10" style="height: 100%">
        <v-layout row justify-center style="height: 100%">
          <v-flex
            v-if="idJenisForm == 1"
            xs4
            md4
            lg4
            xl4
            class="view-surat-left"
          >
            <v-layout column>
              <v-layout row>
                <v-flex xs6 md6 lg6 xl6>
                  <v-text-field
                    readonly
                    v-model="item.tgl_masuk"
                    label="TANGGAL MASUK"
                    style="border-style: none"
                  />
                </v-flex>
                <v-flex xs6 md6 lg6 xl6>
                  <v-text-field
                    readonly
                    v-model="item.index_surat_tu"
                    label="INDEX SURAT TU"
                  />
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs6 md6 lg6 xl6>
                  <v-text-field
                    readonly
                    v-model="item.tgl_surat"
                    label="TANGGAL SURAT"
                  />
                </v-flex>
                <v-flex xs6 md6 lg6 xl6>
                  <v-text-field
                    readonly
                    v-model="item.no"
                    label="NOMOR SURAT"
                  />
                </v-flex>
              </v-layout>
              <v-text-field
                readonly
                label="PENGIRIM"
                rows="2"
                no-resize
                v-model="item.pengirim"
              />
              <v-textarea
                readonly
                label="PERIHAL"
                rows="1"
                no-resize
                v-model="item.perihal"
              />
              <v-textarea
                readonly
                label="RINGKASAN"
                placeholder="-"
                rows="1"
                no-resize
                v-model="item.ringkasan"
              />
            </v-layout>
            <br />
            <v-alert color="info" text v-if="item.status_pimpinan == 'hold'">
              Menunggu Disampaikan
            </v-alert>
            <v-alert color="success" text v-if="item.status_pimpinan == 'send'">
              Telah Disampaikan ke Pimpinan
            </v-alert>
            <v-alert
              color="warning"
              text
              v-if="item.status_pimpinan == 'archive'"
            >
              Surat Diarsipkan
            </v-alert>
          </v-flex>

          <v-flex v-else xs4 md4 lg4 xl4 class="view-surat-left">
            <v-layout column>
              <v-layout row>
                <v-flex xs6 md6 lg6 xl6>
                  <v-text-field
                    readonly
                    v-model="item.tgl_surat"
                    label="TANGGAL SURAT"
                  />
                </v-flex>
                <v-flex xs6 md6 lg6 xl6>
                  <v-text-field
                    readonly
                    v-model="item.no"
                    label="NOMOR SURAT"
                  />
                </v-flex>
              </v-layout>
              <v-textarea
                readonly
                label="PERIHAL"
                rows="2"
                no-resize
                v-model="item.perihal"
              />
              <v-textarea
                readonly
                label="TUJUAN"
                placeholder="-"
                rows="2"
                no-resize
                v-model="item.tujuan"
              />
              <v-textarea
                readonly
                label="ORGANISASI"
                placeholder="-"
                rows="2"
                no-resize
                v-model="item.namaBidang"
              />
            </v-layout>
          </v-flex>
          <!-- LAMPIRAN -->
          <v-flex xs8 md8 lg8 xl8 class="view-surat-right">
            <v-layout column fill-height>
              <v-flex>
                <v-tabs v-model="tab" grow>
                  <v-tab>
                    <v-icon>mdi-file-document-outline</v-icon>
                    Arsip
                  </v-tab>
                  <v-tab>
                    <v-icon>mdi-clipboard-check-outline</v-icon>
                    Disposisi
                  </v-tab>
                </v-tabs>
              </v-flex>
              <v-flex fill-height>
                <div v-if="tab === 0" class="px-2">
                  <iframe
                    v-if="item.lampiran"
                    :src="item.lampiran"
                    width="100%"
                    height="500px"
                  />
                  <div
                    v-else
                    style="margin-top: 100px; display: flex; flex-direction: column; justify-content: center; align-items: center"
                  >
                    <v-icon
                      style="font-size: 48px; margin-bottom: 20px"
                      color="red"
                      >mdi-file-remove</v-icon
                    >
                    <span>Tidak Ada Arsip</span>
                  </div>
                </div>
                <div v-else style="height: 100%">
                  <v-data-table
                    :headers="disposisiHeaders"
                    :items="item.disposisi"
                    hide-default-footer
                    no-data-text="Belum ada disposisi"
                    item-key="id"
                    single-expand
                    show-expand
                    :expanded.sync="expanded"
                    :loading="downloadingDisposisi"
                  >
                    <template v-slot:[`item.disposisi_at`]="{ item }">
                      {{ item.disposisi_at | dateTime }}
                    </template>
                    <template v-slot:[`item.id`]="{ item }">
                      <v-btn
                        rounded
                        small
                        color="primary"
                        text
                        @click.native.stop="downloadDisposisi(item.id)"
                        :disabled="downloadingDisposisi"
                      >
                        <v-icon left>mdi-printer</v-icon>
                        Cetak
                      </v-btn>
                    </template>
                    <template v-slot:expanded-item="{ headers, item }">
                      <td :colspan="headers.length">
                        <div class="tujuan-disposisi">
                          <span>Diteruskan Kepada:</span>
                          <ul>
                            <li
                              v-for="tujuan in item.tujuan"
                              :key="tujuan.jabatan_id"
                            >
                              {{ tujuan.nama_jabatan }}
                            </li>
                          </ul>
                        </div>
                      </td>
                    </template>
                  </v-data-table>
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-card-actions style="padding-right: 2rem;">
      <v-spacer></v-spacer>
      <v-btn color="grey darken-1" text @click="closeView">
        Tutup
      </v-btn>
      <v-btn
        v-if="item.status_pimpinan == 'hold'"
        color="warning darken-1"
        text
        @click="$emit('archive')"
      >
        <v-icon left>mdi-email-lock</v-icon> Arsipkan
      </v-btn>
      <v-btn
        v-if="item.status_pimpinan == 'hold'"
        color="success"
        @click="$emit('approve')"
      >
        <v-icon left>mdi-email-check-outline</v-icon>
        Sampaikan ke Pimpinan
      </v-btn>
      <v-btn
        v-if="item.status_pimpinan == 'send'"
        color="error"
        @click="$emit('restore')"
        outlined
      >
        <v-icon left>mdi-undo</v-icon>
        Batal Sampaikan
      </v-btn>
      <v-btn
        v-if="item.status_pimpinan == 'archive'"
        color="error"
        @click="$emit('restore')"
        outlined
      >
        <v-icon left>mdi-undo</v-icon>
        Batal Arsip
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { downloadKartuDisposisi } from '@/services/surat'
export default {
  props: {
    idJenisForm: { type: Number, default: () => 1 },
    item: { type: Object, default: () => null }
  },
  computed: {},
  data() {
    return {
      tab: 0,
      disposisiHeaders: [
        { text: '', value: 'data-table-expand' },
        {
          text: 'Tgl. Disposisi',
          sortable: false,
          value: 'disposisi_at',
          align: 'left'
        },
        { text: 'Dari', sortable: false, value: 'user_name', align: 'left' },
        { text: 'Instruksi', sortable: false, value: 'note', align: 'left' },
        {
          text: 'Kartu Disposisi',
          sortable: false,
          value: 'id',
          align: 'right'
        }
      ],
      disposisiItems: [],
      expanded: [],
      downloadingDisposisi: false
    }
  },
  methods: {
    closeView() {
      this.$emit('close-view-form')
      this.tab = 0
    },
    async downloadDisposisi(id) {
      this.downloadingDisposisi = true
      await downloadKartuDisposisi(id)
      this.downloadingDisposisi = false
    }
  }
}
</script>

<style scoped>
.tujuan-disposisi {
  padding: 1rem 0.5rem;
}
</style>
